import styled, { css } from 'styled-components';
import Image from '@klv/atoms/image';


const cardTransition = css`transition: .45s ease-in-out;`;

export const StyledButton = styled.div`
  ${({ theme }) => `
    border-radius: 3.2rem;
    ${theme.fonts.sohne.semibold}
    font-size: 1.6rem;
    font-weight: 500;
    text-align: center;
    line-height: 2.0rem;
    padding: 1rem 2.8rem;
    width: 100%;
    max-width: 28.9rem;
    margin: 2.8rem 2.8rem 1.4rem 2.8rem;
    ${cardTransition}
    color: ${theme.colors.white};
    background-color: ${theme.colors.charcoal};
    border: 2px solid ${theme.colors.charcoal};

    ${theme.screenSize.s576.mediaQuery} {
      max-width: 43.4rem;
    }
    ${theme.screenSize.s768.mediaQuery} {
      max-width: 28.9rem;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      margin:  2.8rem 2.5rem 2.6rem 2.5rem;
      max-width: 19.4rem;
      font-size: 1.8rem; 
    }
    ${theme.screenSize.s1200.mediaQuery} {
      max-width: 23.6rem;
      margin: 3.6rem auto 3.8rem auto;
    } 
  `}
`;

export const ImageTextContainer = styled.div`
  top: 0;
  left: 0;
  position: relative;
  overflow: hidden;
  z-index: 0;
  width: 100%; 
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: center;
`;

export const ImageContainer = styled.div`
  width: 100%;
  max-width: 35rem;

  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      display: block;
      width: 100%;
      max-width: 91%;
    }
  `}  
`;

export const CardImage = styled(Image)``;

export const CardImageContainer = styled.div`
  width: 100%;
  max-width: 21rem;
  position: relative;
  bottom: -16px;
  left: 27%;
  height: auto;
  z-index: 3;
  ${cardTransition}
  
  ${({ theme }) => `
    ${theme.screenSize.s576.mediaQuery} {
      max-width: 22.9rem;
      left: 28%;
      bottom: -20px;
    }
    ${theme.screenSize.s768.mediaQuery} {
      max-width: 20.3rem;
      bottom: -25px;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      max-width: 100%;
      bottom: 0;
      top: 0;
      left: 0;
    }
  `};
`;


export const HoverCardImage = styled(Image)``;

export const HoverContainer = styled.div`
  height: auto;
  position: absolute;
  top: 17%;
  z-index: 4;
  opacity: 1;
  ${cardTransition} 

  &.email-marketing-hover-img, &.sms-marketing-hover-img {
      transform: scale(1) translateX(6%);
    }
  &.mobile-push-hover-img {
    top: 8%;
    transform: scale(0.9) translateX(8%);
  }
  &.reviews-hover-img {
    top: 7%;
    transform: scale(0.88) translateX(47%);
  }

  ${({ theme }) => `
    ${theme.screenSize.s576.mediaQuery} {
      &.email-marketing-hover-img, &.sms-marketing-hover-img {
        top: 17%;
        transform: scale(1) translateX(18%);
      }
      &.mobile-push-hover-img {
        top: 11%;
        transform: scale(1) translateX(12%);
      }
      &.reviews-hover-img {
        top: 11%;
        transform: scale(1) translateX(56%);
      }
    }
    ${theme.screenSize.s768.mediaQuery} {
      &.email-marketing-hover-img, &.sms-marketing-hover-img {
        top: 16%;
        transform: scale(0.9) translateX(8%);
      }
      &.mobile-push-hover-img {
        top: 9%;
        transform: scale(0.88) translateX(9%);
      }
      &.reviews-hover-img {
        top: 11%;
        transform: scale(0.9) translateX(55%);
      }
    }
    ${theme.screenSize.s1024.mediaQuery} {
      transform: translateX(130%);
      opacity: 0;
      max-width: 100%;
      &.email-marketing-hover-img, &.sms-marketing-hover-img {
        top: 30%;
        transform: translateX(130%);
      }
      &.mobile-push-hover-img {
        top: 20%;
        transform: translateX(130%);
      }
      &.reviews-hover-img {
        top: 22%;
        transform: translateX(130%);
      }
    }
    ${theme.screenSize.s1200.mediaQuery} {
      &.email-marketing-hover-img, &.sms-marketing-hover-img {
        top: 32%;
      }
      &.mobile-push-hover-img, &.reviews-hover-img {
        top: 26%;
      }
    }
  `}
`;

export const SubHeadline = styled.p`
  font-family: "Sohne";
  font-size: 1.6rem;
  line-height: 1.3;
  text-align: center;
  
  ${({ theme }) => `
    ${theme.screenSize.s1200.mediaQuery} {
      font-size: 1.8rem;
    }
  `}
`;
export const TextContainer = styled.div`
  text-align: center;
  margin: 0 auto;
  padding: 0rem 1rem;
  position: relative;
  
  ${({ theme }) => `
    ${theme.screenSize.s576.mediaQuery} {
      max-width: 43.4rem;
    }
    ${theme.screenSize.s768.mediaQuery} {
      max-width: 30.2rem;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      font-size: 1.6rem;
      max-width: 28.9rem;
      position: absolute;
      z-index: 2;
      top: 40%;
      transition: .5s ease-in-out;
      padding: 0 1rem;
      opacity: 0;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      font-size: 1.8rem;
      line-height: 1.3; 
    }
  `}
`;


export const StyledProductsCard = styled.a`
  grid-column: 1/-1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  overflow: hidden;
  width: 100%;
  max-height: 47.9rem;
  border-radius: 1.5rem;
  text-decoration: none;
  ${cardTransition}
  ${({ theme }) => `
    border: 1px solid ${theme.colors.sand};
    background: linear-gradient(145deg, ${theme.colors.sand} 0%, rgba(0,0,0,0) 55%);
    conic-gradient(from -135deg at 100%  50%, ${theme.colors.sand} 90deg, #0000 0);

    ${theme.screenSize.s576.mediaQuery} {
      max-height: 100%;
    }
    ${theme.screenSize.s768.mediaQuery} {
      grid-column: span 6;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      border: 1px solid ${theme.colors.sandTint};
      background-image: linear-gradient(254deg, rgba(236, 217, 186, 0.10) 0%, rgba(233, 220, 198, 0.00) 100%), 
        linear-gradient(145deg, ${theme.colors.sand} 0%, rgba(0,0,0,0) 35%);
      background-repeat: no-repeat;
      grid-column: span 3;
      background-size: auto, 0 0;
      transition: all .4s;
    }
  `}

  &:hover, &:focus {
    outline: none;

    ${({ theme }) => `
      ${theme.screenSize.s1024.mediaQuery} {
        border: 1px solid ${theme.colors.sand};
        background-size: 0, 100% 100%;
        cursor: pointer;
        box-shadow: 0px 0px 10px rgba(174, 161, 141, 0.51);

        ${StyledButton} {
          background-color: ${theme.colors.transparent};
          color: ${theme.colors.charcoal};
        }
        ${CardImageContainer} {
          transform: scale(0.8) translateY(18%) translateX(33%);
        }
        ${HoverContainer} {
          opacity: 1;

          &.email-marketing-hover-img {
            transform: scale(0.7) translateX(12%);
          }
          &.sms-marketing-hover-img {
            transform: scale(0.7) translateX(12%);
          }
          &.mobile-push-hover-img {
            transform: scale(0.7) translateX(10%);
          }
          &.reviews-hover-img { 
            transform: scale(0.8) translateX(46%);
          }   
        }
        ${TextContainer} {
          top: 18%;
          opacity: 1;
        }
      }
      ${theme.screenSize.s1200.mediaQuery} {
        ${CardImageContainer} {
          transform: scale(0.9) translateY(16%) translateX(29%);
        }
        ${HoverContainer} {
          &.email-marketing-hover-img {
            transform: scale(1) translateX(12%);
          }
          &.sms-marketing-hover-img {
            transform: scale(1) translateX(12%);
          }
          &.mobile-push-hover-img {
            transform: scale(1) translateX(10%);
          }
          &.reviews-hover-img { 
            transform: scale(1) translateX(46%);
          }   
        }
      }
      &:focus-visible {
        outline: 1px dashed ${theme.colors.charcoal};
        outline-offset: 2px;
        border-radius: 1.5rem;

        ${theme.screenSize.s1024.mediaQuery} {
          outline: none;
        }
      }
    `}   
  }
`;

